import React from "react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Pet from "../assets/girl-main_optimized.webp";
import PetXL from "../assets/glavnaProbaXLred1_optimized.webp";
import bg from "../assets/bg.webp";
import Vektor from "../assets/Vector.png";
import Cezar from "../assets/garancija_optimized.webp";
import Utisci from "../assets/new-1_optimized.webp";
import MackaUpitnik from "../assets/mackaUpitnik_optimized.webp";
import Mobile from "../assets/mobile_optimized.webp";
import Boby from "../assets/boby_optimized.webp";
import { FaHeart } from "react-icons/fa";
import KoskicaZl from "../assets/koskica_optimized.webp";
import KoskicaCr from "../assets/koskicaCr_optimized.webp";
import koskicaPl from "../assets/koskicaPL_optimized.webp";
import koskicaRo from "../assets/koskicaRo_optimized.webp";
import SrcePl from "../assets/srceBlue_optimized.webp";
import SrceRo from "../assets/srceRo_optimized.webp";
import Srce from "../assets/srce_optimized.webp";
import SrceBlue from "../assets/srcePl_optimized.webp";
import SrceZl from "../assets/srceZl_optimized.webp";
import KrugPl from "../assets/krug_optimized.webp";
import KrugRo from "../assets/krugRo_optimized.webp";
import KrugOr from "../assets/krugOr_optimized.webp";
import KrugBlue from "../assets/krugBlue_optimized.webp";
import KrugZl from "../assets/krugZl_optimized.webp";
//import JSConfetti from "js-confetti";

const Main1 = () => {
  const [showModal, setShowModal] = React.useState(false);
  const [showModalTags, setShowModalTags] = React.useState(false);
  const getConfetti = () => {
    setShowModalTags(true);
  };
  return (
    <div className="flex justify-center">
      <div className="w-full">
        {/* Glavna */}
      <div className="mt-16 mb-12">
        <h1 className="text-center text-2xl md:text-5xl">Ukoliko ste kupili Pet ID tag, ubacite podatke <Link to="/moj-ljubimac"><p style={{color: "#3BC77E !important"}} className="text-[#3BC77E] underline text-center text-2xl md:text-5xl">ovdje</p></Link></h1>
      </div>
        <div className="flex pt-12 sm:pt-28 flex-col sm:flex-row">
          <div className="lg:ml-16 xl:pl-22 sm:w-[50%] lg:w-[50%] xl:w-[60%] 2xl:w-[80%]">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-center sm:text-left px-3 sm:pl-6 md:pl-6 md:mt-6 lg:mt-9 xl:mt-12 2xl:pb-8">
              Želiš svog ljubimca nazad ako se izgubi?
            </h1>
            <div className="px-6 md:px-8">
              <h4 className="pt-8 font-bold text-lg sm:text-xl md:text-xl lg:text-3xl text-center sm:text-left 2xl:pb-8">
                9 od 10 izgubljenih pasa i mačaka koji imaju Pet ID tag bude
                vraćeno svojim porodicama, i to često za manje od 24 sata!
              </h4>
            </div>
            <div className="px-6">
              <div className="pt-4 flex items-center lg:mb-8 lg:mt-3 xl:mb-0">
                <img className="pr-5" src={Vektor} alt="Vektor" />
                <p className="text-black text-[18px] md:text-lg lg:text-xl font-semibold">
                  Veoma lako se uočava sa razdaljine od 10 metara, i lako se
                  očitava pomoću mobilnog koji ima svaki pronalazač.
                </p>
              </div>
              <div className="pt-6 flex items-center lg:mb-8 xl:mb-0">
                <img className="pr-5" src={Vektor} alt="Vektor" />
                <p className="text-black text-[18px] md:text-lg lg:text-xl font-semibold">
                  Ne smeta vašem ljubimcu kada se igra, spava ili kupa, jer je
                  mali, savitljiv i vodootporan.
                </p>
              </div>
              <div className="pt-6 flex items-center lg:mb-8 xl:mb-0">
                <img className="pr-5" src={Vektor} alt="Vektor" />
                <p className="text-black text-[18px] md:text-lg lg:text-xl font-semibold">
                  Specijalno dizajniran sastav materijala od koga je izrađen Pet
                  ID tag, tako da bude potpuno bezopasan i za vašeg ljubimca, i
                  za okolinu. Netoksične boje. Apsolutno sigurna kopča.
                </p>
              </div>
            </div>
            <div className="flex wrap flex-col sm:flex-row">
              <div
                className="px-2 md:px-8 flex justify-center lg:justify-start"
                style={{ zIndex: "5" }}
              >
                <div className="flex items-center justify-center text-white bg-[#3BC77E] w-full sm:w-[300px] h-[64px] rounded-lg mt-16 duration-500 hover:bg-[#FF553E]">
                  <h3
                    className="text-[1.3rem] min-[410px]:text-[1.75rem]"
                    onClick={() => getConfetti()}
                  >
                    Boje i oblici
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div className="">
            <LazyLoadImage
              effect="blur"
              alt="Pet"
              src={Pet}
              className="mt-12 sm:mt-0 lg:w-full m-auto sm:block 2xl:pl-48"
              style={{ zIndex: "1" }}
            />
          </div>
        </div>
        {showModalTags ? (
          <>
            <div className="justify-center items-center fixed inset-0 z-50 overflow-auto outline-none focus:outline-none">
              <div className="relative w-auto my-6 mx-auto max-w-3xl">
                {/*content*/}
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  {/*header*/}
                  <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                    <h3 className="text-3xl font-semibold flex items-center">
                      SVE BOJE I OBLICI
                      <span className="pl-2 text-[#ff0000]">
                        <FaHeart size={20} />
                      </span>
                      <span className="pl-2 text-[#ff0000]">
                        <FaHeart size={20} />
                      </span>
                      <span className="pl-2 text-[#ff0000]">
                        <FaHeart size={20} />
                      </span>
                    </h3>
                    <button
                      className="p-1 ml-auto bg-transparent border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                      onClick={() => {
                        setShowModalTags(false);
                      }}
                    >
                      <span className="bg-transparent text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                        x
                      </span>
                    </button>
                  </div>
                  {/*body*/}
                  <div className="relative p-6 flex flex-col min-[450px]:flex-row">
                    <div className="w-full sm:block pr-1 pl-1">
                      <div className="flex flex-wrap place-content-evenly">
                        <figure>
                          <LazyLoadImage
                            className="boje_oblici"
                            effect="blur"
                            src={KoskicaZl}
                            loading="lazy"
                            decoding="async"
                            alt="KoskicaZl"
                          />
                        </figure>
                        <figure>
                          <LazyLoadImage
                            className="boje_oblici"
                            effect="blur"
                            src={KoskicaCr}
                            loading="lazy"
                            decoding="async"
                            alt="KoskicaCr"
                          />
                        </figure>
                        <figure>
                          <LazyLoadImage
                            className="boje_oblici"
                            effect="blur"
                            src={koskicaPl}
                            loading="lazy"
                            decoding="async"
                            alt="koskicaPl"
                          />
                        </figure>
                        <figure>
                          <LazyLoadImage
                            className="boje_oblici"
                            effect="blur"
                            src={koskicaRo}
                            loading="lazy"
                            decoding="async"
                            alt="koskicaRo"
                          />
                        </figure>
                        <figure>
                          <LazyLoadImage
                            className="boje_oblici"
                            effect="blur"
                            src={SrceRo}
                            loading="lazy"
                            decoding="async"
                            alt="SrceRo"
                          />
                        </figure>
                        <figure>
                          <LazyLoadImage
                            className="boje_oblici"
                            effect="blur"
                            src={SrcePl}
                            loading="lazy"
                            decoding="async"
                            alt="SrcePl"
                          />
                        </figure>
                        <figure>
                          <LazyLoadImage
                            className="boje_oblici"
                            effect="blur"
                            src={Srce}
                            loading="lazy"
                            decoding="async"
                            alt="Srce"
                          />
                        </figure>
                        <figure>
                          <LazyLoadImage
                            className="boje_oblici"
                            effect="blur"
                            src={SrceBlue}
                            loading="lazy"
                            decoding="async"
                            alt="SrceBlue"
                          />
                        </figure>
                        <figure>
                          <LazyLoadImage
                            className="boje_oblici"
                            effect="blur"
                            src={SrceZl}
                            loading="lazy"
                            decoding="async"
                            alt="SrceZl"
                          />
                        </figure>
                        <figure>
                          <LazyLoadImage
                            className="boje_oblici"
                            effect="blur"
                            src={KrugRo}
                            loading="lazy"
                            decoding="async"
                            alt="KrugRo"
                          />
                        </figure>
                        <figure>
                          <LazyLoadImage
                            className="boje_oblici"
                            effect="blur"
                            src={KrugOr}
                            loading="lazy"
                            decoding="async"
                            alt="KrugOr"
                          />
                        </figure>
                        <figure>
                          <LazyLoadImage
                            className="boje_oblici"
                            effect="blur"
                            src={KrugBlue}
                            loading="lazy"
                            decoding="async"
                            alt="KrugBlue"
                          />
                        </figure>
                        <figure>
                          <LazyLoadImage
                            className="boje_oblici"
                            effect="blur"
                            src={KrugPl}
                            loading="lazy"
                            decoding="async"
                            alt="KrugPl"
                          />
                        </figure>
                        <figure>
                          <LazyLoadImage
                            className="boje_oblici"
                            effect="blur"
                            src={KrugZl}
                            loading="lazy"
                            decoding="async"
                            alt="KrugZl"
                          />
                        </figure>
                      </div>
                    </div>
                  </div>
                  {/*footer*/}
                  <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                    <button
                      className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => {
                        setShowModalTags(false);
                      }}
                    >
                      Zatvori
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        ) : null}
        {/* Utisci */}
        <div
          className="flex 2xl:justify-center pt-20 xl:pt-18 pb-10 w-full min-[1032px]:flex-row items-center flex-col-reverse"
          style={{
            backgroundImage: `url(${bg})`,
            backgroundRepeat: "no repeat",
            backgroundSize: "100%",
          }}
        >
          <div className="w-full xl:pr-12">
            <img
              // effect="blur"
              // loading="lazy"
              // decoding="async"
              alt="Utisci"
              className="w-[700px] rounded-lg"
              src={Utisci}
            />
          </div>
          <div className="w-full xl:pr-18 2xl:pr-12">
            <h2 className="min-[368px]:px-6 text-3xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold pb-8 mt-12 sm:mt-0 text-center sm:text-left">
              Neki od utisaka...
            </h2>
            <div className="px-6 text-left 2xl:pr-24">
              <blockquote>
                <p className="font-semibold text-black text-[18px] lg:text-xl sm:pr-6">
                  Jedan od najstrašnijih momenata u životu mi je bio kad sam se
                  okrenula oko sebe i shvatila da Paka nema nigde. Preplakala
                  sam popodne ali već istog dana zvao me je čovjek i rekao -
                  “Našao sam vašeg psa, hajde da se nađemo da vam ga vratim”.
                </p>
              </blockquote>
              <br />
              <blockquote>
                <p className="font-semibold text-black text-[18px] lg:text-xl sm:pr-6">
                  Moja Milica ne izlazi nigdje, ona je tipična kućna maca, i ne
                  znam šta joj je bilo da pobjegne, ali srećom, posle užasne
                  neprospavane noći sutradan je zvao dečko koji je pronašao u
                  svom ulazu kako mjauče i traži pomoć. Zvao me je i nisam mogla
                  da verujem da mi se moja Milica vraća u krilo. Hvala Pet ID
                  tagu!!!!
                </p>
              </blockquote>
            </div>
          </div>
        </div>
        <h4
          onClick={() => setShowModal(true)}
          className="pt-8 font-bold text-xl md:text-xl lg:text-3xl text-center text-[#fff] bg-[#3BC77E] pb-8 border-[2px] border-dashed border-lightgray-500 cursor-pointer"
        >
          Možeš pogledati kako izgleda stranica Pet ID taga online{" "}
          <span className="text-[#dd4733] border-b-[3px] border-[#dd4733]">
            OVDJE
          </span>{" "}
          :
        </h4>
        {/* Odgovori na pitanja */}
        <div
          className="flex flex-col-reverse sm:flex-row sm:pt-3 md:pt-20 items-center text-center sm:text-left "
          style={{
            backgroundImage: `url(${bg})`,
            backgroundRepeat: "no repeat",
            backgroundSize: "100%",
          }}
        >
          <div className="w-full lg:w-[80%] xl:w-[80%] lg:pl-16 px-3">
            <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold">
              Odgovaramo na pitanja
            </h1>
            <h4 className="pt-8 font-bold text-xl md:text-xl lg:text-3xl">
              Zar mi čip nije dovoljan?! Ne, jer osoba koja pronađe tvog psa ili
              mačku možda:
            </h4>
            <div className="pt-12 flex items-center text-left pl-[10%] pr-6 sm:pr-0 sm:pl-0">
              <p className="text-black text-[18px] sm:text-md md:text-lg lg:text-xl font-semibold">
                • nema vremena da ode do veterinara da očita čip,
                <br />• nema auto i način da ode do veterinara da očita čip,
                <br />• nema veterinara u blizini mjesta pronalaska,
                <br />• ne zna da li pas ili mačka imaju čip, pa mu/joj se ne
                ide džabe do veterinara,
                <br />• plaši se da vašeg ljubimca transportuje jer ne zna da li
                voli da se vozi,
                <br />• nema adekvatan transporter, pa se plaši da mu/joj ne
                pobjegne
              </p>
            </div>
          </div>
          <div className="xl:block flex justify-end px-0 mx-0 lg:ml-12 xl:ml-0">
            <LazyLoadImage
              effect="blur"
              loading="lazy"
              decoding="async"
              alt="SrceRo"
              src={MackaUpitnik}
              className="lg:w-[600px]"
            />
          </div>
        </div>   
        {/* Poruci */}
        {showModal ? (
          <>
            <div className="justify-center items-center fixed inset-0 z-50 overflow-auto outline-none focus:outline-none">
              <div className="relative w-auto my-6 mx-auto max-w-3xl">
                {/*content*/}
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  {/*header*/}
                  <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                    <h3 className="text-3xl font-semibold flex items-center">
                      Boby online{" "}
                      <span className="pl-2 text-[#ff0000]">
                        <FaHeart size={20} />
                      </span>
                      <span className="pl-2 text-[#ff0000]">
                        <FaHeart size={20} />
                      </span>
                      <span className="pl-2 text-[#ff0000]">
                        <FaHeart size={20} />
                      </span>
                    </h3>
                    <button
                      className="p-1 ml-auto bg-transparent border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                      onClick={() => {
                        setShowModal(false);
                      }}
                    >
                      <span className="bg-transparent text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                        x
                      </span>
                    </button>
                  </div>
                  {/*body*/}
                  <div className="relative p-6 flex flex-col min-[450px]:flex-row">
                    <div className="w-full sm:block pr-7 pl-1">
                      <div className="flex md:justify-center">
                        <LazyLoadImage
                          effect="blur"
                          loading="lazy"
                          decoding="async"
                          alt="Mobile"
                          src={Mobile}
                          className="rounded-lg"
                        />
                      </div>
                    </div>
                    <div className="w-full sm:block pr-7 pl-1">
                      <div className="flex md:justify-center">
                        <LazyLoadImage
                          effect="blur"
                          loading="lazy"
                          decoding="async"
                          alt="Boby_O"
                          src={Boby}
                          className="rounded-lg"
                        />
                      </div>
                    </div>
                  </div>
                  {/*footer*/}
                  <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                    <button
                      className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => {
                        setShowModal(false);
                      }}
                    >
                      Zatvori
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        ) : null}
        {/* Garancija */}
        <div
          className="flex justify-center 2xl:pb-6"
          style={{
            backgroundImage: `url(${bg})`,
            backgroundRepeat: "no repeat",
            backgroundSize: "100%",
          }}
        >
          <LazyLoadImage
            effect="blur"
            alt="Pet"
            src={PetXL}
            className="pt-0 min-[1471px]:mt-1 min-[1638px]:pt-3 m-auto px-6 xl:px-0"
          />
        </div>
        <div
          className="w-full sm:pt-8 pb-32 text-center sm:text-left"
          style={{
            backgroundImage: `url(${bg})`,
            backgroundRepeat: "no repeat",
            backgroundSize: "100%",
          }}
        >
          <div className="flex justify-center flex-col sm:flex-row pt-10">
            <div className="sm:w-full lg:w-[50%] px-6 sm:px-0 flex m-auto justify-center">
              <LazyLoadImage
                effect="blur"
                loading="lazy"
                decoding="async"
                alt="SrceRo"
                src={Cezar}
                className="m-auto"
              />
            </div>

            <div className="w-full lg:w-[70%] lg:pr-20 2xl:pr-[190px]">
              <div className="px-6">
                <h2 className="text-[#FF553E] text-3xl md:text-5xl lg:text-4xl xl:text-4xl 2xl:text-6xl font-bold md:text-left sm:mt-0 mt-6">
                  100% garancija na zadovoljstvo!
                </h2>
                <p className="pt-8 text-[18px] sm:text-md md:text-lg lg:text-xl font-semibold text-black text-left">
                  Toliko smo sigurni u kvalitet i pouzdanost našeg Pet ID taga,
                  da vam garantujemo povraćaj novca u cjelokupnom iznosu i to bez
                  ikakvih pitanja prilikom zahtjeva za povrat u roku od 30 dana!
                </p>
                <p className="pt-8 text-[18px] sm:text-md md:text-lg lg:text-xl font-semibold text-black text-left">
                  Specijalno dizajniran materijal na bazi silikonske gume,
                  netoksične boje, apsolutna sigurnost kopči, bezbednost
                  podataka na najmodernijim serverima, enkriptovana razmjena
                  podataka i novčanih transakcija, da navedemo samo neke od
                  stvari koje predstavljaju potvrdu vrhunskog kvaliteta našeg
                  proizvoda i usluge.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main1;
